import { checkActive, LEOPAY_TITLE_NAME } from "../Constant";

export const setUser = (token, name, uid, session, reqId, mid) => {
  console.log("common", token, name, uid, session, reqId);
  sessionStorage.setItem("token", JSON.stringify(token));
  // sessionStorage.setItem("profileId", JSON.stringify(profileId));
  sessionStorage.setItem("name", JSON.stringify(name));
  sessionStorage.setItem("uid", JSON.stringify(uid));
  sessionStorage.setItem("sessionid", JSON.stringify(session));
  sessionStorage.setItem("reqId", JSON.stringify(reqId));
  sessionStorage.setItem("mid", JSON.stringify(mid));
};
export const getUser = () =>
  sessionStorage.getItem("token")
    ? JSON.parse(sessionStorage.getItem("token"))
    : "";

export const getToken = () => {
  return sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
    ? JSON.parse(sessionStorage.getItem("token")).token
    : "";
};

export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("profileId");
  sessionStorage.removeItem("name");
  sessionStorage.removeItem("sessiontoken");
  //name
};

//REACT_APP_DISTRIBUTOR

var distributerList = [];
export const isUserAdmin = (loggedRetailerId) => {
  const filterRetailerAndRole = distributerList.filter(
    (val) => val.id == loggedRetailerId
  );
  //console.log('filterRetailer', filterRetailerAndRole)
  if (filterRetailerAndRole.length > 0) {
    return true;
  } else {
    return false;
  }
};
export const isSuperAdmin = (loggedRetailerId) => {
  const isSuperAdminUser = process.env.REACT_APP_SUPER_ADMIN;
  const filterRetailerAndRole = distributerList.filter(
    (val) => val.id == loggedRetailerId
  );
  if (
    filterRetailerAndRole.length > 0 &&
    filterRetailerAndRole[0].role == isSuperAdminUser
  ) {
    return true;
  } else {
    return false;
  }
};

const checkcommercialName = (value) => {
  return /^[a-zA-Z0-9 ]{5,50}$/.test(value);
};

export const validCommercialName = new RegExp("^[a-zA-Z0-9 ]{5,50}$");

const checkName = (value) => {
  return /^[A-Za-z.\s_-]+$/.test(value);
};
const checkMobileNumber = (value) => {
  return /^[0-9]{10}$/.test(value);
};
const checkAccountNumber = (value) => {
  return /^[0-9]$/.test(value);
};
const checkEmailId = (value) => {
  return /^\S+@\S+\.\S+$/.test(value);
};
const checkAddress = (value) => {
  return /[^a-zA-Z0-9\,\-\/ ]/.test(value);
};
const checkPassword = (value) => {
  return /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/.test(value);
};
//
const checkDob = (value) => {
  return /^(\d{1,2})-(\d{1,2})-(\d{4})$/.test(value);
};
const checkAlphanumeric = (value) => {
  return /^[a-z0-9]+$/.test(value);
};
const checkValidateWeight = (value) => {
  return /^[1-9][0-9]*$/.test(value);
};

const checkURL = (value) => {
  var httpRegex =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
  return httpRegex.test(value);
};
const allnumeric = (inputtxt) => {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers)) {
    return true;
  } else {
    return false;
  }
};
const stylesofStype = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "none",
    borderColor: "none",
    border: "none",
    padding: "0px",
    borderRadius: "0px",
    minHeight: "16px",
    boxShadow: "none",
    fontSize: "16px",
  }),
  valueContainer: (styles) => ({
    ...styles,
    backgroundColor: "none",
    border: "none",
    padding: "0px",
    borderRadius: "0px",
  }),
  multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
  //IndicatorsContainer
  input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
  //singleValue
  singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
};
const stylesofStypeNew = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "none",
    borderColor: "red",
    border: "0px",
    padding: "0px",
    borderRadius: "0px",
    minHeight: "10px",
    boxShadow: "none",
    fontSize: "16px",
  }),
  valueContainer: (styles) => ({
    ...styles,
    backgroundColor: "none",
    border: "none",
    padding: "0px 12px",
    borderRadius: "0px",
  }),
  multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
  IndicatorsContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
  }),
  indicatorContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
  }),
  input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
  //singleValue
  singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
};
//`/api/v1/proxy/mobile/order/history/mis`
var paymentStatus = [
  { id: "SUCCESS", count: 0, total: 0 },
  { id: "FAILED", count: 0, total: 0 },
  { id: "PENDING", count: 0, total: 0 },
  { id: "OTHER", count: 0, total: 0 },
];
const fetchStatus = async (
  pageindex,
  id,
  isAdmin,
  selectedId,
  setDataLoading,
  setsearch,
  axiosInstance,
  url,
  requesterId,
  uuid,
  formDate,
  currentDate,
  nextDate,
  toDate,
  finalSelectedStatus,
  setTransactionStatuswithAmount,
  setIsDataLoaded,
  toast,
  e,
  finalSelectedtxnCat
) => {
  //console.log('finalSelectedtxnCat', finalSelectedtxnCat)
  setDataLoading(true);
  setsearch("");
  const reqPayload = {
    header: {
      "client-id": id, // client id will admin id
      role: "ROLE_RETAILER_FINXPAY",
      msgType: "ORDER_HISTORY",
      channel: "ADMIN",
      requesterId: requesterId,
      requestId: uuid(),
      time: new Date(),
    },
    device: null,
    agentId: isAdmin ? selectedId : id,
    pageNo: pageindex,
    startDate: formDate == "" ? currentDate : formDate,
    endDate: toDate == "" ? nextDate : toDate,
    status:
      finalSelectedStatus !== undefined && finalSelectedStatus.length !== 0
        ? finalSelectedStatus
        : null,
  };
  if (finalSelectedtxnCat !== undefined && finalSelectedtxnCat?.length !== 0) {
    reqPayload.txnCategory = finalSelectedtxnCat;
  } else if (
    finalSelectedtxnCat !== undefined &&
    finalSelectedtxnCat?.length == 0
  ) {
    reqPayload.txnCategory = null;
  }
  const response = await axiosInstance
    .post(url, reqPayload, {
      headers: {
        Authorization: `Bearer ${e}`,
        "client-id": id,
        role: "ROLE_RETAILER_FINXPAY",
      },
    })
    .then((res) => {
      let result2 = res?.data?.data || [];
      var result1 = [...paymentStatus];
      let finalResult = [...result1, ...result2];
      const arrayUniqueByKey = [
        ...finalResult
          .reduce(
            (r, o) =>
              !r.has(o.id) ||
              r.get(o.id).count < o.count ||
              r.get(o.id).total < o.total
                ? r.set(o.id, o)
                : r,
            new Map()
          )
          .values(),
      ];
      const addFilnalTotalSatus = arrayUniqueByKey.map((val, ins, self) => {
        if (val.id == "SUCCESS" || val.id == "FAILED" || val.id == "PENDING") {
          return val;
        } else {
          const currentObj = self[3];
          currentObj.count = currentObj.count + val.count;
          currentObj.total = currentObj.total + val.total;
          return currentObj;
        }
      });
      const unique = [...new Set(addFilnalTotalSatus)];
      //   console.log('unique', unique)
      setTransactionStatuswithAmount(unique);
    })
    .catch((err) => {
      //console.log(err);
      setDataLoading(false);
      setIsDataLoaded(false);
      toast.error("Something went wrong");
    });

  if (response) {
    const result = response.data.orders;

    if (result) {
    }

    return response.data;
  }
  return false;
};
const requestLoading = () => (
  <div class="overlay">
    <div class="overlay__inner">
      <div class="overlay__content">
        <span class="spinner"></span>
      </div>
    </div>
  </div>
);

async function copyTextToClipboard(text, toast) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Text copied to clipboard.", { autoClose: 100 });
  } catch (err) {
    console.error("Unable to copy text to clipboard:", err);
    toast.error("Failed to copy text to clipboard.");
  }
}
// Usage

const klikpayTitle = "KlikPay Merchant Portal";
const paytomTitle = "Paytom Merchant Portal";
const title = process.env.REACT_APP_TITLE;
// const primaryColor='#009adb'
// const dangerColor = "#bf4b43"
let primaryColor = "";
let dangerColor = "";
let navbarColor = "";
if (title === paytomTitle) {
  primaryColor = process.env.REACT_APP_PRIMARY_COLOR_PAYTOM;
  dangerColor = process.env.REACT_APP_DANGER_COLOR_PAYTOM;
  navbarColor = process.env.REACT_APP_NAV_COLOR_PAYTOM;
} else if (title === klikpayTitle) {
  primaryColor = process.env.REACT_APP_PRIMARY_COLOR_KLIKPAY;
  dangerColor = process.env.REACT_APP_DANGER_COLOR_KLIKPAY;
  navbarColor = process.env.REACT_APP_NAV_COLOR_KLIKPAY;
} else if (title === "QRBonPay Merchant Portal") {
  primaryColor = process.env.REACT_APP_PRIMARY_COLOR_QRBonPay;
  dangerColor = process.env.REACT_APP_DANGER_COLOR_QRBonPay;
  navbarColor = process.env.REACT_APP_NAV_COLOR_QRBonPay;
} else if (title === LEOPAY_TITLE_NAME) {
  primaryColor = process.env.REACT_APP_PRIMARY_COLOR_leopay;
  dangerColor = process.env.REACT_APP_DANGER_COLOR_leopay;
  navbarColor = process.env.REACT_APP_NAV_COLOR_leopay;
}
function formatNumberForIndia(number) {
  // Convert the number to a string and split it into integer and fractional parts
  let [integerPart, fractionalPart] = number.toString().split(".");

  // Format the integer part
  let lastThree = integerPart.slice(-3);
  let otherNumbers = integerPart.slice(0, -3);
  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }
  let formattedIntegerPart =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  // Combine the formatted integer part with the fractional part (if it exists)
  let result = fractionalPart
    ? formattedIntegerPart + "." + fractionalPart
    : formattedIntegerPart;

  return result;
}
const showpageCount = (firstIndex, finalIndex) => {
  let firstInd = 0;
  if (firstIndex == 0) {
    firstInd = firstIndex + 1;
  } else {
    firstInd = firstIndex;
  }
  return `Showing ${firstInd} to ${finalIndex}`;
};

function darkenColor(hex, amount = 20) {
  console.log("hexhex", hex);
  let color = hex.replace("#", "");

  // If color is shorthand (e.g., #fff), expand it to full form (e.g., #ffffff)
  if (color.length === 3) {
    color = color
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) - amount;
  let g = ((num >> 8) & 0x00ff) - amount;
  let b = (num & 0x0000ff) - amount;

  // Clamp values between 0 and 255
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}
const utrLeng = (utr) => {
  const values = utr !== undefined && utr !== null ? utr : "";
  return values;
};

const stylesofStyleWithColor = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "none",
    borderColor: "red",
    border: "0px",
    padding: "0px",
    borderRadius: "0px",
    minHeight: "10px",
    height: "auto", // Ensure the height is auto
    boxShadow: "none",
    fontSize: "16px",
  }),
  valueContainer: (styles) => ({
    ...styles,
    backgroundColor: "none",
    border: "none",
    padding: "0px 12px",
    borderRadius: "0px",
    height: "auto", // Allow it to adjust based on content
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    lineHeight: "16px",
    height: "auto", // Ensure multi-value items wrap properly
    backgroundColor:
      data.status === "active"
        ? "rgba(0, 255, 0, 0.1)"
        : "rgba(255, 0, 0, 0.1)", // Light green/red background
    border: `1px solid ${data.status === "active" ? "green" : "red"}`,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    height: "auto", // Ensure the text adjusts dynamically
    color: data.status === "active" ? "green" : "red",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    height: "auto",
    color: data.status === "active" ? "green" : "red",
    ":hover": {
      backgroundColor:
        data.status === "active"
          ? "rgba(0, 255, 0, 0.2)"
          : "rgba(255, 0, 0, 0.2)",
      color: data.status === "active" ? "green" : "red",
    },
  }),
  IndicatorsContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
    height: "auto",
  }),
  indicatorContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
    height: "auto",
  }),
  input: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
    height: "auto",
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    fontSize: "14px",
    color: data.status === "active" ? "green" : "red",
    height: "auto",
  }),
};

function extractUniqueAccNamesAndVPAsForwhitelistMid(
  accounts,
  type,
  checkStatus
) {
  const accMap = {};
  console.log("aaaaaMMM", accounts);

  accounts.forEach((account) => {
    const { bankerId, id } = account;

    if (account.whitelistMid.length > 0 && account?.type === type) {
      if (!accMap[bankerId]) {
        // Initialize the object based on checkStatus
        if (checkStatus) {
          accMap[bankerId] = { id: [], status: "" }; // Include status
        } else {
          accMap[bankerId] = { id: [] }; // No status field
        }
      }

      // Set the status only if it's not already set to "active"
      if (
        checkStatus &&
        (accMap[bankerId].status === "" ||
          accMap[bankerId].status === "inactive")
      ) {
        let status = checkActive(account) ? "active" : "inactive";
        accMap[bankerId].status = status; // Add status to the bankerId object
      }

      // Ensure id is unique before adding
      if (!accMap[bankerId].id.includes(id)) {
        accMap[bankerId].id.push(id);
      }
    }
  });

  // Convert the accMap object into an array of objects
  return Object.entries(accMap).map(([bankerId, { id, status }]) => {
    const result = { bankerId, id };
    if (checkStatus) {
      result.status = status; // Only add status if checkStatus is true
    }
    return result;
  });
}
export {
  checkcommercialName,
  checkName,
  checkMobileNumber,
  checkEmailId,
  checkAddress,
  checkAccountNumber,
  checkPassword,
  checkDob,
  checkAlphanumeric,
  allnumeric,
  checkValidateWeight,
  checkURL,
  stylesofStype,
  stylesofStypeNew,
  fetchStatus,
  paymentStatus,
  requestLoading,
  primaryColor,
  dangerColor,
  navbarColor,
  copyTextToClipboard,
  formatNumberForIndia,
  showpageCount,
  klikpayTitle,
  paytomTitle,
  darkenColor,
  utrLeng,
  stylesofStyleWithColor,
  extractUniqueAccNamesAndVPAsForwhitelistMid,
};
